import React from "react";
import styled from "@emotion/styled";
import Spinner from "../components/Spinner";

interface Props {
  orderNumber: string | undefined;
}
const WiredIFrame = (props:Props) => {
  const wiredSection = props.orderNumber?.toLowerCase().startsWith("madex") ? "exchange" : "title";

  return (
    <Root>
      <Spinner local={true} display={true} />
      <iframe
        title="Wired"
        src={`https://wired.mcres.com/${wiredSection}?orderNumber=${props.orderNumber}`}
        width="650"
        height="500"
      />
    </Root>
  );
};

export default WiredIFrame;

const Root = styled.div<{ iframeDisplay?: boolean }>`
  width:"650";
  height: "500";
  position: relative;
  z-index: 5;
  iframe {
    z-index: 265;
    position: relative;
  }
`;
